import axios from "axios";
import * as actionType from "../constants/actionTypes";
let qs = require("qs");


/*** GetStudentsByDormitoryId Action ***/
export const GetStudentsByDormitoryIdStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.GetStudentsByDormitoryId_START,
    };
};
export const GetStudentsByDormitoryIdSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.GetStudentsByDormitoryId_SUCCESS,
    };
};
export const GetStudentsByDormitoryIdFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.GetStudentsByDormitoryId_FAIL,
    };
};
export const GetStudentsByDormitoryId = (page, limit, sort, order, search, dormitory_id ) => {
    const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
    return (dispatch) => {
        dispatch(GetStudentsByDormitoryIdStart());
        return axios({
            method: "get",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("bss_authtoken")}`,
                country_host: user_info?.country_host ,
                school_code: user_info?.school_code,
            },
            url: `${actionType.environment_url}/api/bss-admin/GetStudentsByDormitoryId`,
            params: {
                page: page,
                limit: limit,
                sort: sort,
                order: order,
                search: search,
                dormitory_id:dormitory_id,
            },
            paramsSerializer: (params) => {
                return qs.stringify(params);
            },
        })
            .then(function (response) {
                dispatch(GetStudentsByDormitoryIdSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(GetStudentsByDormitoryIdFail("Something went wrong, Please try again."));
                return error;
            });
    };
};
